import { Link, useLocation } from "react-router-dom";
import { tokenDecode } from "../../../utils/helper";
import { useState } from "react";
import logoimg from "../../../../src/icons/ix_logo.png"
import styles from "./Side_bar.module.css";
import { useEffect } from "react";
import { config } from "../../../utils/config";
import axios from "axios";
import jwt_decode from "jwt-decode";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaidIcon from '@mui/icons-material/Paid';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import GroupIcon from '@mui/icons-material/Group';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import Navbar from "../navbar";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { useHistory } from "react-router-dom";
import MovingIcon from '@mui/icons-material/Moving';
import PercentIcon from '@mui/icons-material/Percent';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import GavelIcon from '@mui/icons-material/Gavel';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
const { apiEndpoint } = config;

/* Chevron used everywhere instead of the old fa-angle-right / fa-angle-down */
const Chevron = ({ open }) => (
  <svg
    className={styles.chev}
    style={{ transform: open ? "rotate(90deg)" : "rotate(0deg)" }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M9 18l6-6-6-6" />
  </svg>
);

const SECTION_PATHS = {
  products: ["/newcategory", "/subcategory", "/brand", "/producttypelist", "/producttype", "/productlist", "/mcrbrands"],
  "master-catalog": ["/logrejection", "/instorecatalog", "/createproduct", "/masterproductlist", "/master-catalogue"],
  orders: ["/orderlist", "/customerorder", "/completeOrder", "/cancelOrderlist", "/returnorders", "/rspdashboard"],
  transaction: ["/unsettledtransactions", "/transaction"],
  issues: ["/issues", "/raiseissue", "/supportlist", "/grievancesettings"],
  saleschannels: ["/ondcsaleschannel"],
  users: ["/roles", "/adduser", "/userlist"],
  sellers: ["/addseller", "/sellerlist", "/tax"],
  inventoryless: ["/bidding", "/findproduct"],
  settings: ["/settings"],
  channelMargin: ["/channelmargin", "/channelmarginlist"],
  rider: ["/addrider", "/riderlist", "/riderdeliveries"],
};

function pathIsActive(pathname, path) {
  return pathname === path || pathname.startsWith(`${path}/`);
}

function computeOpenSections(pathname) {
  const open = {};
  Object.keys(SECTION_PATHS).forEach((id) => {
    open[id] = SECTION_PATHS[id].some((p) => pathIsActive(pathname, p));
  });
  return open;
}

/** @param {{ onClose?: () => void }} props */
const Sidebar = ({ onClose }) => {
  const location = useLocation();
  const [arrows, setArrows] = useState(() => computeOpenSections(location.pathname));
  const decoded = tokenDecode();
  const history = useHistory()
  const { data } = decoded;
  const { permission: { category, order, product, role, seller, tax, user, location: locationPermission, product_master_catalog, igm, transaction, channel_margin, rider, warehouse }, } = data;

  if (decoded) {
    // ok
  } else {
    console.log("no");
  }

  const [numberOfNAP, setnumberOfNAP] = useState([]);
  const [sidebarShow, setsidebarShow] = useState(checkstatus());

  function checkstatus() {
    const token = sessionStorage.getItem("us_st_d");
    const tokenDecode = jwt_decode(token);
    return tokenDecode.data.user.approve_status;
  }

  useEffect(() => {
    async function getNAP() {
      try {
        const { data } = await axios({
          url: `${apiEndpoint}/listNonApproveProductSeller`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
          },
          data: {
            seller_id: decoded?.data?.user?.seller_id,
          },
        });

        if (data.status === 200) {
          setnumberOfNAP(data.data);
        }
      } catch (error) { }
    }

    function handleResize() {
      const location = window.location.href.split("/")
      if (window.innerWidth > 766) {
        if (location[location.length - 1] == "sidebar") {
          history.push("/dashboard")
        }
      }
    }

    window.addEventListener('resize', handleResize);
  }, []);

  // Keep the correct section expanded (and its parent marked active) whenever
  // the route changes, instead of relying on Bootstrap's collapse JS to survive
  // React re-renders.
  useEffect(() => {
    setArrows(computeOpenSections(location.pathname));
  }, [location.pathname]);

  let current_sellerid = decoded.data.user.seller_id;

  const handleClick = (id) => {
    setArrows((prevArrows) => {
      const newArrows = Object.fromEntries(
        Object.entries(prevArrows).map(([key, value]) => [key, false])
      );
      newArrows[id] = !prevArrows[id];
      return newArrows;
    });
  };

  const isTF = (decoded?.data?.user?.seller_id === 505 || decoded?.data?.user?.email == "tf1001@ondc.org" || decoded?.data?.user?.email == "tf1002@ondc.org");

  return (
    <>
      
      {sidebarShow == 1 ? (
        <ul className={`navbar-nav sidebar-dark accordion ${styles.side_bar}`} id="accordionSidebar">

          {onClose && (
            <button type="button" className={styles.closeButton} aria-label="Close navigation menu" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          )}

          <Link to="/dashboard">
            <a href="replace" className={`sidebar-brand ${styles.brandLink}`}>
              <img src={logoimg} alt="logo here" className={styles.sideBarLogo} />
              <span>
                <span className={styles.brandName}>Inventoryless</span>
                <span className={styles.brandTagline}>Seller Admin</span>
              </span>
            </a>
          </Link>

          <div className={styles.sectionLabel}>Main</div>

          <li className={styles.navItem}>
            <Link to="/dashboard">
              <a href="replace" className={`${styles.navLink} ${pathIsActive(location.pathname, "/dashboard") ? styles.active : ""}`}>
                <div className={styles.listItems}>
                  <span className={styles.navIconWrap}>
                    <DashboardCustomizeIcon fontSize="small" />
                  </span>
                  <span>Dashboard</span>
                </div>
              </a>
            </Link>
          </li>

          {product?.read ? <>
            {(category?.write || category?.read) ? (
              <li className={styles.navItem}>
                <Link to="#">
                  <a
                    className={`${styles.navLink} ${arrows["products"] ? styles.active : ""}`}
                    href="replace"
                    aria-expanded={arrows["products"] ? "true" : "false"}
                    aria-controls="collapseTwo"
                    id="products"
                    onClick={() => handleClick("products")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}>
                        <PendingActionsIcon fontSize="small" />
                      </span>
                      {current_sellerid == 1 ? <span>Products</span> : null}
                    </div>
                    <Chevron open={arrows["products"]} />
                  </a>
                </Link>
                <div id="collapseTwo" style={{ display: arrows["products"] ? "block" : "none" }} aria-labelledby="headingTwo">
                  <div className={styles.submenu}>
                    {category?.write ? (
                      <Link to="/newcategory">
                        <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/newcategory") || pathIsActive(location.pathname, "/subcategory") ? styles.active : ""}`}><span className={styles.subDot}></span>Category</a>
                      </Link>
                    ) : null}
                    {/* {category?.write && (
                      <Link to="/brand">
                        <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/brand") ? styles.active : ""}`}><span className={styles.subDot}></span>Brand</a>
                      </Link>
                    )} */}
                    {(category?.write || category?.read) && (
                      <Link to="/producttypelist">
                        <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/producttypelist") || pathIsActive(location.pathname, "/producttype") ? styles.active : ""}`}><span className={styles.subDot}></span>Product Type</a>
                      </Link>
                    )}
                    {(current_sellerid < 2 && current_sellerid !== 0) && (
                      <Link to="/productlist">
                        <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/productlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Products</a>
                      </Link>
                    )}
                    {current_sellerid === 1 ? (
                      <Link to="/mcrbrands">
                        <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/mcrbrands") ? styles.active : ""}`}><span className={styles.subDot}></span>MCR Brands</a>
                      </Link>
                    ) : null}
                  </div>
                </div>
              </li>
            ) : null}

            <li className={styles.navItem} style={{ display: isTF ? "none" : "block" }}>
              <Link to="#">
                <a
                  className={`${styles.navLink} ${arrows["master-catalog"] ? styles.active : ""}`}
                  href="replace"
                  aria-expanded={arrows["master-catalog"] ? "true" : "false"}
                  aria-controls="mastercatalog"
                  id="master-catalog"
                  onClick={() => handleClick("master-catalog")}
                >
                  <div className={styles.listItems}>
                    <span className={styles.navIconWrap}>
                      <ListAltIcon fontSize="small" />
                    </span>
                    <span>Catalog</span>
                  </div>
                  <Chevron open={arrows["master-catalog"]} />
                </a>
              </Link>
              <div id="mastercatalog" style={{ display: arrows["master-catalog"] ? "block" : "none" }} aria-labelledby="headingTwo">
                <div className={styles.submenu}>
                  {(current_sellerid < 2 && current_sellerid !== 0 && product.read) ? (
                    <Link to="/logrejection">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/logrejection") ? styles.active : ""}`}><span className={styles.subDot}></span>Catalog Rejection</a>
                    </Link>
                  ) : (
                    <>
                      {product.read ? (
                        <Link to="/instorecatalog">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/instorecatalog") ? styles.active : ""}`}><span className={styles.subDot}></span>In-Store Products</a>
                        </Link>
                      ) : null}
                      {/* {product.write ? (
                        <Link to="/createproduct">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/createproduct") ? styles.active : ""}`}><span className={styles.subDot}></span>Create Product</a>
                        </Link>
                      ) : null} */}
                    </>
                  )}
                  {product_master_catalog?.read ? (
                    <Link to="/masterproductlist">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/masterproductlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Master Product List</a>
                    </Link>
                  ) : null}
                  {(product?.read && current_sellerid !== 1) ? (
                    <Link to="/master-catalogue">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/master-catalogue") ? styles.active : ""}`}><span className={styles.subDot}></span>Master Catalogue</a>
                    </Link>
                  ) : null}
                </div>
              </div>
            </li>
          </> : null}

          <li className={styles.navItem} style={{ display: isTF ? "block" : "none" }}>
            <Link to="/allorderslist">
              <a className={`${styles.navLink} ${pathIsActive(location.pathname, "/allorderslist") ? styles.active : ""}`} href="replace" id="order">
                <div className={styles.listItems}>
                  <span className={styles.navIconWrap}><ReceiptLongIcon fontSize="small" /></span>
                  <span>Order</span>
                </div>
              </a>
            </Link>
          </li>

          {/* <li className={styles.navItem} style={{ display: isTF ? "block" : "none" }}>
            <Link to="/rspdashboard">
              <a className={`${styles.navLink} ${pathIsActive(location.pathname, "/rspdashboard") ? styles.active : ""}`} href="replace" id="order">
                <div className={styles.listItems}>
                  <span className={styles.navIconWrap}><SettingsApplicationsIcon fontSize="small" /></span>
                  <span>RSF</span>
                </div>
              </a>
            </Link>
          </li> */}

          <li className={styles.navItem} style={{ display: isTF ? "block" : "none" }}>
            <Link to="/supportlist">
              <a className={`${styles.navLink} ${pathIsActive(location.pathname, "/supportlist") ? styles.active : ""}`} href="replace" id="order">
                <div className={styles.listItems}>
                  <span className={styles.navIconWrap}><ReceiptLongIcon fontSize="small" /></span>
                  <span>Customer Support</span>
                </div>
              </a>
            </Link>
          </li>

          {(order?.read || transaction?.read) ? (
            order?.read ? (
              <li className={styles.navItem}>
                <Link to="#">
                  <a
                    className={`${styles.navLink} ${arrows["orders"] ? styles.active : ""}`}
                    href="replace"
                    aria-expanded={arrows["orders"] ? "true" : "false"}
                    aria-controls="collapseTwo_1"
                    id="orders"
                    onClick={() => handleClick("orders")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><ReceiptLongIcon fontSize="small" /></span>
                      <span>Orders</span>
                    </div>
                    <Chevron open={arrows["orders"]} />
                  </a>
                </Link>
                <div id="collapseTwo_1" style={{ display: arrows["orders"] ? "block" : "none" }} aria-labelledby="headingTwo">
                  <div className={styles.submenu}>
                    {((current_sellerid === 1 && decoded?.data?.user?.parent_id === 0) || (current_sellerid == 0 && decoded?.data?.user?.parent_id === 1)) &&
                      <Link to="/orderlist">
                        <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/orderlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Order List</a>
                      </Link>
                    }

                    {decoded?.data?.user?.seller_id > 1 || (decoded?.data?.user?.seller_id === 0 && decoded?.data?.user?.parent_id !== 1) ? (
                      <>
                        <Link to="/customerorder">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/customerorder") ? styles.active : ""}`}><span className={styles.subDot}></span>Active Orders</a>
                        </Link>
                        <Link to="/completeOrder">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/completeOrder") ? styles.active : ""}`}><span className={styles.subDot}></span> Delivered Orders</a>
                        </Link>
                        <Link to="/cancelOrderlist">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/cancelOrderlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Cancelled Orders</a>
                        </Link>
                      </>
                    ) : null}

                    <Link to="/returnorders">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/returnorders") ? styles.active : ""}`}><span className={styles.subDot}></span>Return Orders List</a>
                    </Link>

                    {/* {(current_sellerid === 1 || decoded.data.user.id === 493) ? (
                      decoded.data.user.id !== 493 && (
                        <Link to="/rspdashboard">
                          <a href="replace" id="order" className={`${styles.subItem} ${pathIsActive(location.pathname, "/rspdashboard") ? styles.active : ""}`}><span className={styles.subDot}></span>RSF</a>
                        </Link>
                      )
                    ) : null} */}
                  </div>
                </div>
              </li>
            ) : null
          ) : null}

          {(transaction?.read && decoded.data.user.parent_id !== 519) ? (
            <li className={styles.navItem}>
              <Link to="#">
                <a
                  className={`${styles.navLink} ${arrows["transaction"] ? styles.active : ""}`}
                  href="replace"
                  aria-expanded={arrows["transaction"] ? "true" : "false"}
                  aria-controls="collapseTwo1_1"
                  id="transaction"
                  onClick={() => handleClick("transaction")}
                >
                  <div className={styles.listItems}>
                    <span className={styles.navIconWrap}><PaidIcon fontSize="small" /></span>
                    <span>Transaction</span>
                  </div>
                  <Chevron open={arrows["transaction"]} />
                </a>
              </Link>
              <div id="collapseTwo1_1" style={{ display: arrows["transaction"] ? "block" : "none" }} aria-labelledby="headingTwo">
                <div className={styles.submenu}>
                  {transaction?.read ? (
                    <Link to="/unsettledtransactions">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/unsettledtransactions") ? styles.active : ""}`}><span className={styles.subDot}></span>Unsettled Transaction</a>
                    </Link>
                  ) : null}
                  {transaction?.read ? (
                    <Link to="/transaction">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/transaction") ? styles.active : ""}`}><span className={styles.subDot}></span>Settled Transaction</a>
                    </Link>
                  ) : null}
                </div>
              </div>
            </li>
          ) : null}

          {(igm?.read || igm?.write) ? (
            <li className={styles.navItem}>
              <Link to="#">
                <a
                  className={`${styles.navLink} ${arrows["issues"] ? styles.active : ""}`}
                  href="replace"
                  aria-expanded={arrows["issues"] ? "true" : "false"}
                  aria-controls="collapseThree"
                  id="issues"
                  onClick={() => handleClick("issues")}
                >
                  <div className={styles.listItems}>
                    <span className={styles.navIconWrap}><ContactSupportIcon fontSize="small" /></span>
                    <span>IGM Portal</span>
                  </div>
                  <Chevron open={arrows["issues"]} />
                </a>
              </Link>
              <div id="collapseThree" style={{ display: arrows["issues"] ? "block" : "none" }} aria-labelledby="headingTwo">
                <div className={styles.submenu}>
                  <Link to="/issues">
                    <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/issues") ? styles.active : ""}`}><span className={styles.subDot}></span>IGM</a>
                  </Link>
                  {/* <Link to="/raiseissue">
                    <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/raiseissue") ? styles.active : ""}`}><span className={styles.subDot}></span>Raise Issue</a>
                  </Link> */}
                  {current_sellerid === 1 ? (
                    <Link to="/supportlist">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/supportlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Customer Support</a>
                    </Link>
                  ) : null}
                  <Link to="/grievancesettings">
                    <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/grievancesettings") ? styles.active : ""}`}><span className={styles.subDot}></span>Grievance Settings</a>
                  </Link>
                </div>
              </div>
            </li>
          ) : null}

          {/* {(igm?.read || igm?.write) ? (
            <li className={styles.navItem}>
              <Link to="#">
                <a
                  className={`${styles.navLink} ${arrows["saleschannels"] ? styles.active : ""}`}
                  href="replace"
                  aria-expanded={arrows["saleschannels"] ? "true" : "false"}
                  aria-controls="collapseSalesChannel"
                  id="saleschannels"
                  onClick={() => handleClick("saleschannels")}
                >
                  <div className={styles.listItems}>
                    <span className={styles.navIconWrap}><MovingIcon fontSize="small" /></span>
                    <span>Channels</span>
                  </div>
                  <Chevron open={arrows["saleschannels"]} />
                </a>
              </Link>
              <div id="collapseSalesChannel" style={{ display: arrows["saleschannels"] ? "block" : "none" }} aria-labelledby="headingTwo">
                <div className={styles.submenu}>
                  <Link to="/ondcsaleschannel">
                    <a href="replace" className={`${styles.subItem} d-flex justify-content-between align-items-center ${pathIsActive(location.pathname, "/ondcsaleschannel") ? styles.active : ""}`}>
                      <span><span className={styles.subDot}></span>ONDC</span>
                      <span style={{ color: "green", fontSize: "12px", fontWeight: 900 }}>Active</span>
                    </a>
                  </Link>
                  {current_sellerid === 1 ? (
                    <a className={`${styles.subItem} d-flex justify-content-between align-items-center`}>
                      <span><span className={styles.subDot}></span>Amazon</span>
                      <span style={{ color: "red", fontSize: "12px", fontWeight: 900 }}>Coming Soon</span>
                    </a>
                  ) : null}
                  <a className={`${styles.subItem} d-flex justify-content-between align-items-center`}>
                    <span><span className={styles.subDot}></span>Flipkart</span>
                    <span style={{ color: "red", fontSize: "12px", fontWeight: 900 }}>Coming Soon</span>
                  </a>
                  <a className={`${styles.subItem} d-flex justify-content-between align-items-center`}>
                    <span><span className={styles.subDot}></span>Unicommerce</span>
                    <span style={{ color: "red", fontSize: "12px", fontWeight: 900 }}>Coming Soon</span>
                  </a>
                </div>
              </div>
            </li>
          ) : null} */}

          <section style={{ display: isTF ? "none" : "block" }}>
            <div className={styles.sectionLabel}>Manage</div>

            <li className={styles.navItem}>
              {/* <Link to="#">
                <a
                  className={styles.navLink}
                  href="replace"
                  data-toggle="collapse"
                  data-target="#collapseAnalytics"
                  aria-expanded="true"
                  aria-controls="collapseAnalytics"
                  id="analytics"
                  onClick={() => handleClick("analytics")}
                >
                  <div className={styles.listItems}>
                    <span className={styles.navIconWrap}><SettingsApplicationsIcon fontSize="small" /></span>
                    <span>Analytics</span>
                  </div>
                  <Chevron open={arrows["analytics"]} />
                </a>
              </Link> */}
              <div id="collapseAnalytics" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                <div className={styles.submenu}>
                  <a href="https://app.powerbi.com/reportEmbed?reportId=32a9defa-cb8b-4174-b0db-b46dd51168ed&autoAuth=true&ctid=bf6a59b4-348c-4cfa-8b66-1ed70ae6a714" target="_blank" rel="noreferrer" className={styles.subItem}>
                    <span className={styles.subDot}></span>Analytics
                  </a>
                  <Link to="/loglist">
                    <a className={styles.subItem}><span className={styles.subDot}></span>Logs</a>
                  </Link>
                </div>
              </div>
            </li>

            <li className={styles.navItem}>
              {user?.read || user?.write || role?.write ? (
                <>
                  <Link
                    to="#"
                    className={`${styles.navLink} ${arrows["users"] ? styles.active : ""}`}
                    aria-expanded={arrows["users"] ? "true" : "false"}
                    aria-controls="collapseOne"
                    id="users"
                    onClick={() => handleClick("users")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><SupervisedUserCircleIcon fontSize="small" /></span>
                      <span>Users</span>
                    </div>
                    <Chevron open={arrows["users"]} />
                  </Link>
                  <div id="collapseOne" style={{ display: arrows["users"] ? "block" : "none" }} aria-labelledby="headingTwo">
                    <div className={styles.submenu}>
                      {role?.write ? (
                        <Link to="/roles">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/roles") ? styles.active : ""}`}><span className={styles.subDot}></span>Roles</a>
                        </Link>
                      ) : null}
                      {user?.write ? (
                        <Link to="/adduser">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/adduser") ? styles.active : ""}`}><span className={styles.subDot}></span>Add user</a>
                        </Link>
                      ) : null}
                      {user?.read ? (
                        <Link to="/userlist">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/userlist") ? styles.active : ""}`}><span className={styles.subDot}></span>User List</a>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : null}
            </li>

            <li className={styles.navItem}>
              {seller?.read || seller?.write || tax?.write ? (
                <>
                  <Link
                    to="#"
                    className={`${styles.navLink} ${arrows["sellers"] ? styles.active : ""}`}
                    aria-expanded={arrows["sellers"] ? "true" : "false"}
                    aria-controls="seller11"
                    onClick={() => handleClick("sellers")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><GroupIcon fontSize="small" /></span>
                      <span>Sellers Management</span>
                    </div>
                    <Chevron open={arrows["sellers"]} />
                  </Link>
                  <div id="seller11" style={{ display: arrows["sellers"] ? "block" : "none" }} aria-labelledby="headingTwo">
                    <div className={styles.submenu}>
                      {seller?.write ? (
                        <Link to="/addseller">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/addseller") ? styles.active : ""}`}><span className={styles.subDot}></span>Add seller</a>
                        </Link>
                      ) : null}
                      {seller?.read ? (
                        <Link to="/sellerlist">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/sellerlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Seller List</a>
                        </Link>
                      ) : null}
                      {tax.write ? (
                        <Link to="/tax">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/tax") ? styles.active : ""}`}><span className={styles.subDot}></span>Tax</a>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : null}
            </li>

            {(current_sellerid === 1 || warehouse?.read || locationPermission?.read) && (
              <li className={styles.navItem}>
                <Link to="/warehouselist">
                  <a href="replace" className={`${styles.navLink} ${pathIsActive(location.pathname, "/warehouselist") ? styles.active : ""}`}>
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><WarehouseIcon fontSize="small" /></span>
                      <span>Warehouse</span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {current_sellerid === 1 && (
              <li className={styles.navItem}>
                <Link to="/policytemplatelist">
                  <a href="replace" className={`${styles.navLink} ${pathIsActive(location.pathname, "/policytemplatelist") || pathIsActive(location.pathname, "/policytemplate") ? styles.active : ""}`}>
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><GavelIcon fontSize="small" /></span>
                      <span>Policy Templates</span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {current_sellerid === 1 && (
              <li className={styles.navItem}>
                <Link to="/foslist">
                  <a href="replace" className={`${styles.navLink} ${pathIsActive(location.pathname, "/foslist") || pathIsActive(location.pathname, "/fos") ? styles.active : ""}`}>
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><PersonPinCircleIcon fontSize="small" /></span>
                      <span>FOS</span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {product.write && (
              <li className={styles.navItem}>
                <Link to="#">
                  <a
                    className={`${styles.navLink} ${arrows["inventoryless"] ? styles.active : ""}`}
                    href="replace"
                    aria-expanded={arrows["inventoryless"] ? "true" : "false"}
                    aria-controls="collapseInventoryless"
                    id="inventoryless"
                    onClick={() => handleClick("inventoryless")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><SettingsApplicationsIcon fontSize="small" /></span>
                      <span>Biddings</span>
                    </div>
                    <Chevron open={arrows["inventoryless"]} />
                  </a>
                </Link>
                <div id="collapseInventoryless" style={{ display: arrows["inventoryless"] ? "block" : "none" }} aria-labelledby="headingTwo">
                  <div className={styles.submenu}>
                    <Link to="/bidding">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/bidding") ? styles.active : ""}`}><span className={styles.subDot}></span>Biddings</a>
                    </Link>
                    <Link to="/findproduct">
                      <a className={`${styles.subItem} ${pathIsActive(location.pathname, "/findproduct") ? styles.active : ""}`}><span className={styles.subDot}></span>Find Products</a>
                    </Link>
                  </div>
                </div>
              </li>
            )}

            {/* {product.write && (
              <li className={styles.navItem}>
                <Link to="#">
                  <a
                    className={`${styles.navLink} ${arrows["settings"] ? styles.active : ""}`}
                    href="replace"
                    aria-expanded={arrows["settings"] ? "true" : "false"}
                    aria-controls="collapseSettings"
                    id="settings"
                    onClick={() => handleClick("settings")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><SettingsApplicationsIcon fontSize="small" /></span>
                      <span>Settings</span>
                    </div>
                    <Chevron open={arrows["settings"]} />
                  </a>
                </Link>
                <div id="collapseSettings" style={{ display: arrows["settings"] ? "block" : "none" }} aria-labelledby="headingTwo">
                  <div className={styles.submenu}>
                    <Link to="/settings">
                      <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/settings") ? styles.active : ""}`}><span className={styles.subDot}></span>Settings</a>
                    </Link>
                  </div>
                </div>
              </li>
            )} */}
            <li className={styles.navItem}>
              {(channel_margin?.read || channel_margin?.write) ? (
                <>
                  <Link
                    to="#"
                    className={`${styles.navLink} ${arrows["channelMargin"] ? styles.active : ""}`}
                    aria-expanded={arrows["channelMargin"] ? "true" : "false"}
                    aria-controls="channelMarginCollapse"
                    onClick={() => handleClick("channelMargin")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><PercentIcon fontSize="small" /></span>
                      <span>Channel Margin</span>
                    </div>
                    <Chevron open={arrows["channelMargin"]} />
                  </Link>
                  <div id="channelMarginCollapse" style={{ display: arrows["channelMargin"] ? "block" : "none" }} aria-labelledby="headingTwo">
                    <div className={styles.submenu}>
                      {/* {channel_margin?.write ? (
                        <Link to="/channelmargin">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/channelmargin") ? styles.active : ""}`}><span className={styles.subDot}></span>Create Channel Margin</a>
                        </Link>
                      ) : null} */}
                      {channel_margin?.read ? (
                        <Link to="/channelmarginlist">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/channelmarginlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Channel Margin List</a>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : null}
            </li>

            <li className={styles.navItem}>
              {(rider?.read || rider?.write || current_sellerid === 1) ? (
                <>
                  <Link
                    to="#"
                    className={`${styles.navLink} ${arrows["rider"] ? styles.active : ""}`}
                    aria-expanded={arrows["rider"] ? "true" : "false"}
                    aria-controls="riderCollapse"
                    onClick={() => handleClick("rider")}
                  >
                    <div className={styles.listItems}>
                      <span className={styles.navIconWrap}><TwoWheelerIcon fontSize="small" /></span>
                      <span>Rider</span>
                    </div>
                    <Chevron open={arrows["rider"]} />
                  </Link>
                  <div id="riderCollapse" style={{ display: arrows["rider"] ? "block" : "none" }} aria-labelledby="headingTwo">
                    <div className={styles.submenu}>
                      {(current_sellerid !== 1 && rider?.write) ? (
                        <Link to="/addrider">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/addrider") ? styles.active : ""}`}><span className={styles.subDot}></span>Add Rider</a>
                        </Link>
                      ) : null}
                      {(current_sellerid !== 1 && rider?.read) ? (
                        <Link to="/riderlist">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/riderlist") ? styles.active : ""}`}><span className={styles.subDot}></span>Rider List</a>
                        </Link>
                      ) : null}
                      {current_sellerid === 1 ? (
                        <Link to="/riderdeliveries">
                          <a href="replace" className={`${styles.subItem} ${pathIsActive(location.pathname, "/riderdeliveries") ? styles.active : ""}`}><span className={styles.subDot}></span>All Deliveries</a>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : null}
            </li>
          </section>
        </ul>
      ) : (
        <></>
      )}
    </>
  );
};

export default Sidebar;